// extracted by mini-css-extract-plugin
export default {"container":"burger-ingredients_container__cxv5M","header":"burger-ingredients_header__ul7pj","groups":"burger-ingredients_groups__SXiFb"};